import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Box } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
import { useAppContext } from 'contexts/AppContext';
import { wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import { observer } from 'mobx-react';
import MobileOriginSingleRow from './MobileOriginSingleRow';
import { MobileOriginSingleRowProps } from './MobileOriginSingleRow/MobileOriginSingleRow';
import { getMobileOriginRows } from './FsMobileOriginForm.utils';

const FsMobileOriginForm: React.FC = () => {
  const {
    redirectsMobile: {
      getRedirects: getRedirectsMobile,
      setRedirects: setRedirectsMobile,
      init: initRedirectsMobile,
      update: updateRedirectsMobile,
    },
  } = useAppContext();
  const rows = getMobileOriginRows(getRedirectsMobile());
  const { enqueueSnackbar } = useSnackbar();
  const [pending, setPending] = useState<boolean>(false);

  const handleChange = ({
    name: key,
    redirect: value,
  }: MobileOriginSingleRowProps) => {
    setRedirectsMobile({
      [key]: value,
    });
  };

  const handleUpdate = async () => {
    setPending(true);
    // eslint-disable-next-line no-console
    console.log('UPDATE:', getRedirectsMobile());
    await wait(1000);
    setPending(false);
    enqueueSnackbar(
      defaultLocales.updateIosAndroidRedirectsNotificationSuccess,
      {
        variant: 'success',
      }
    );
    updateRedirectsMobile();
  };

  useEffect(() => {
    initRedirectsMobile();
  }, [initRedirectsMobile]);

  return (
    <Box maxWidth={600}>
      <Box>
        {/* <pre>{JSON.stringify(originRows, null, 2)}</pre> */}
        {rows.map(({ name, ...otherProps }) => (
          <MobileOriginSingleRow
            key={name}
            {...{ name, ...otherProps }}
            onChange={(changedField) => handleChange({ ...changedField })}
          />
        ))}
      </Box>
      <FsPendingButton
        pending={pending}
        onClick={handleUpdate}
        startIcon={<SyncIcon />}
      >
        {defaultLocales.update}
      </FsPendingButton>
    </Box>
  );
};

export default observer(FsMobileOriginForm);
